
import { defineComponent, ref } from 'vue';
import { Button, Icon } from 'vant';
import ActiveList from '@/components/ActiveList.vue';
import { getUserInfo } from '@/http/myhome';
import { useRouter, useRoute } from 'vue-router';
import { getMyBacklog, getMyActiveCase, getMyCaseInfo } from '@/http/home';

export default defineComponent({
  components: {
    [Button.name]: Button,
    ActiveList,
    [Icon.name]: Icon,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const userName: any = ref('');
    const myBackList = ref([]);
    const myActiveList = ref([]);
    const myHouser = ref({});
    // 跳转
    const onJump = (item: string, pro: string, type: number, status: string) => {
      router.push({
        path: '/caseform',
        query: { projectId: pro, type, status },
      });
    };
    const getDatil = () => {
      // 首页统计
      getMyCaseInfo().then((res: any) => {
        myHouser.value = res.result;
      });
      // 待完成
      getMyBacklog().then((res: any) => {
        myBackList.value = res.result;
      });
      // 参与案件
      getMyActiveCase().then((res: any) => {
        myActiveList.value = res.result;
      });
    };
    if (sessionStorage.getItem('userName')) {
      getDatil();
      userName.value = sessionStorage.getItem('userName');
    } else {
      getUserInfo({ code: route.query.code }).then((res: any) => {
        const { name, id } = res.result;
        userName.value = name;
        sessionStorage.setItem('userId', id);
        sessionStorage.setItem('userName', name);
        getDatil();
      });
    }

    return {
      userName,
      myBackList,
      myActiveList,
      onJump,
      myHouser,
    };
  },
});
